"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const asyncIterate_1 = __importDefault(require("../Util/asyncIterate"));
const Unit_1 = require("./Unit");
const asFloat_1 = __importDefault(require("../Util/asFloat"));
const countCustomers_1 = __importStar(require("./countCustomers"));
const cache_1 = require("@almservices-cl/cache");
const exception_1 = require("@almservices-cl/exception");
const clock_1 = require("@almservices-cl/clock");
const calculateBudget_1 = require("../Util/calculateBudget");
class Customer {
    constructor(customerList, notes, tokenService, customerCache, notifications, calorieBudget, foodPreference, strategy, dateTimeBridge, logger, customerAdapter, customerSubscriptionBusiness, dayTypeApi) {
        this.notificationsObservers = {};
        this.rawCustomersLiveData = new cache_1.Observable();
        this.getCustomersLiveData = new cache_1.Observable();
        this.customersLiveData = [];
        this.customerListObservableSuccessHandler = (timeZone) => (rawCustomers) => {
            this.getCustomersLiveData.setValue({
                items: rawCustomers.map((customer) => this.mapCustomer(customer, timeZone)),
                counters: {
                    subscriptionType: {
                        original: (0, countCustomers_1.default)(rawCustomers, "original"),
                        premium: (0, countCustomers_1.default)(rawCustomers, "premium"),
                        plus: (0, countCustomers_1.default)(rawCustomers, "plus"),
                    },
                    membersToCoachInDay: (0, countCustomers_1.countCustomersCoachingDays)(rawCustomers),
                },
            });
        };
        this.getCustomers = (timeZone, id) => {
            this.rawCustomersLiveData.onSuccess(this.customerListObservableSuccessHandler(timeZone), id);
            this.triggerRawCustomersList().catch((e) => {
                this.logger.error(e);
                this.getCustomersLiveData.setError(e);
            });
            this.rawCustomersLiveData.onError(this.getCustomersLiveData.setError);
            return this.getCustomersLiveData;
        };
        this.getCustomer = async (id, timeZone) => {
            return this.mapCustomer(await this.fetchCustomer(id), timeZone);
        };
        this.fetchCustomer = async (customerId) => {
            const customer = this.customersLiveData.find((r) => {
                return r.id === customerId;
            });
            if (customer) {
                return customer;
            }
            try {
                const customer = await this.customerCache
                    .getCustomers(async () => {
                    return await this.customerApi.getCustomers();
                })
                    .then((customers) => {
                    return customers.find((c) => c.id === customerId);
                });
                if (!customer) {
                    throw new exception_1.OutOfRangeException("not accepted");
                }
                return customer;
            }
            catch (e) {
                if (e instanceof Error) {
                    this.logger.error(e);
                    throw new exception_1.OutOfRangeException(`Customer of id "${customerId}" was not found`, e);
                }
                throw Error("Uncaught error: fetching customer");
            }
        };
        this.mapCustomer = (customer, timeZone) => {
            return this.customerAdapter.adapt(customer, timeZone);
        };
        this.getCustomerNote = async (customerId) => this.customerCache.getNote(customerId, async () => {
            return this.notes.getCustomerNote(await this.tokenService.getValidToken(), customerId);
        });
        this.setCustomerNote = async (customerId, note) => {
            const token = await this.tokenService.getValidToken();
            await this.notes.setCustomerNote(token, customerId, note);
            await this.customerCache.setNote(customerId, {
                body: note,
            });
        };
        this.markUserAsRead = async (customerId) => {
            this.logger.log(`Marking customer of id "${customerId}" as read`);
            await this.customerApi.markCustomerAsRead(customerId);
            this.clearCustomerNotifications(customerId);
        };
        this.getCustomerNotifications = (customerId) => {
            const observable = new cache_1.Observable(`Customer ${customerId} Notifications`);
            this.registerNotificationsObservable(observable, customerId);
            return observable;
        };
        this.getLatestIntakeInfo = async (customerId) => {
            const customer = await this.fetchCustomer(customerId);
            return this.customerCache.getLatestIntakeInfo(customer.id, async () => this.filterEmptyIntakeQuestions(await this.customerApi.getLatestIntakeInfo(customer)));
        };
        this.filterEmptyIntakeQuestions = (intake) => {
            const questionsFilter = ({ answer }) => !!answer;
            return {
                ...intake,
                questions: intake.questions.filter(questionsFilter),
                xQuestions: intake.xQuestions.filter(questionsFilter),
            };
        };
        this.getCustomerCalorieBudget = async (customerId, unit) => {
            const bundle = await this.customerCache.getCalorieBudget(customerId, () => this.calorieBudget.getCalorieBudget(customerId));
            return {
                ...bundle,
                forNonTrainingDay: this.convertCalorieBudget(bundle.forNonTrainingDay, Unit_1.Unit.METRIC, unit),
                forTrainingDay: this.convertCalorieBudget(bundle.forTrainingDay, Unit_1.Unit.METRIC, unit),
            };
        };
        this.setCalorieBudgets = async (customerId, calorieBudgets, unit, isSecure) => {
            await this.calorieBudget.setCalorieBudgets(await this.fetchCustomer(customerId), calorieBudgets, isSecure);
            const budgetsToModify = calorieBudgets
                .map((budget) => this.convertCalorieBudget({
                ...budget,
                calories: 0,
                fibers: 0,
            }, unit, Unit_1.Unit.METRIC))
                .map(calculateBudget_1.calculateBudget);
            const bundle = {
                forTrainingDay: budgetsToModify.find((budget) => budget.isForTrainingDays),
                forNonTrainingDay: budgetsToModify.find((budget) => !budget.isForTrainingDays),
            };
            return this.customerCache.setCalorieBudget(customerId, bundle);
        };
        this.getFoodPreferences = (customerId) => this.strategy.get(`FOOD_PREFERENCES.${customerId}`, () => this.foodPreference.getFoodPreferences(customerId));
        this.setCoachingDays = async (customerId, coachingDays) => {
            await this.customerApi.changeCoachingDay(await this.fetchCustomer(customerId), coachingDays);
            const customer = await this.fetchCustomer(customerId);
            customer.subscriptionPeriod.coachingDays = coachingDays;
            this.triggerRawCustomersList().catch(this.logger.error);
            await this.customerCache.setCustomer(customer);
        };
        this.triggerCustomerNotification = async (customerId) => {
            if (this.notificationsObservers[customerId] === undefined) {
                this.logger.warn(`Customer Notification Observer of id "${customerId}" was not found`);
                return;
            }
            const { notifications } = await this.getCustomer(customerId, clock_1.UTCTimeZone.z());
            await (0, asyncIterate_1.default)(this.notificationsObservers[customerId], async (observer) => {
                observer.setValue(notifications);
            });
            this.logger.log(`Customer Notification Observers "${customerId}" Called`);
        };
        this.resetCustomersObservable = async () => {
            this.rawCustomersLiveData.clear();
            this.getCustomersLiveData.clear();
        };
        this.clearCustomerNotifications = async (customerId) => {
            const newNotifications = {
                hasUnseenMeal: false,
                hasUnreadMessage: false,
                hasUnseenTraining: false,
                hasUnseenRecovery: false,
                hasUnseenBehaviour: false,
                hasUnseenMeasurement: false,
                hasUnseenLife: false,
                hasUnseenMind: false,
            };
            await this.customerCache.setNotifications(customerId, newNotifications);
            await this.triggerCustomerNotification(customerId);
            const customers = await this.rawCustomersLiveData.asPromise();
            const customer = customers.find((customer) => customer.id === customerId);
            customers.push(customers.splice(customers.indexOf(customer), 1)[0]);
            customer.responseDeadLine = null;
            customer.notifications = newNotifications;
            await this.customerCache.setCustomer(customer);
            this.rawCustomersLiveData.setValue(customers);
        };
        this.triggerRawCustomersList = async () => {
            await this.fetchRawCustomers();
        };
        this.fetchRawCustomers = async () => {
            const rawCustomers = await this.customerCache.getCustomers(async () => {
                return await this.customerApi.getCustomers();
            });
            this.rawCustomersLiveData.setValue(rawCustomers);
        };
        this.convertCalorieBudget = (calorieBudget, from, to) => {
            if (from === to) {
                return calorieBudget;
            }
            let ratio = Customer.G_TO_OZ;
            let fractionDigits = 1;
            if (to === Unit_1.Unit.METRIC) {
                ratio = Customer.OZ_TO_G;
                fractionDigits = 0;
            }
            return {
                ...calorieBudget,
                carbohydrates: (0, asFloat_1.default)(this.recalc(calorieBudget.carbohydrates, ratio), fractionDigits),
                fats: (0, asFloat_1.default)(this.recalc(calorieBudget.fats, ratio), fractionDigits),
                proteins: (0, asFloat_1.default)(this.recalc(calorieBudget.proteins, ratio), fractionDigits),
                fibers: (0, asFloat_1.default)(this.recalc(calorieBudget.fibers, ratio), fractionDigits),
            };
        };
        this.recalc = (number, ratio) => Math.round(number * ratio * 10) / 10;
        this.getCustomerSubscriptions = async (id) => {
            const { subscriptions, currentSubscriptionId } = await this.strategy.get(`CUSTOMER_SUBSCRIPTIONS.${id}`, () => this.customerApi.getCustomerSubscriptions(id));
            return this.customerSubscriptionBusiness.sortSubscriptionsByCurrentSubscription(subscriptions, currentSubscriptionId);
        };
        this.getDayType = (customerId, date) => this.dayTypeApi.getDayType(customerId, this.dateTimeBridge.systemDate(date));
        this.unSubscribeCustomerList = (id) => {
            this.getCustomersLiveData.removeSuccessHandler(id);
        };
        this.getCustomerActions = async (customerId) => {
            return this.notifications.getCustomerActions(customerId);
        };
        this.dismissCustomerAction = async (actionId) => {
            return this.notifications.dismissCustomerAction(actionId);
        };
        this.notes = notes;
        this.customerApi = customerList;
        this.tokenService = tokenService;
        this.customerCache = customerCache;
        this.notifications = notifications;
        this.calorieBudget = calorieBudget;
        this.foodPreference = foodPreference;
        this.strategy = strategy;
        this.dateTimeBridge = dateTimeBridge;
        this.logger = logger;
        this.customerAdapter = customerAdapter;
        this.customerSubscriptionBusiness = customerSubscriptionBusiness;
        this.dayTypeApi = dayTypeApi;
        this.rawCustomersLiveData.onSuccess((r) => {
            this.customersLiveData = r;
        });
    }
    registerNotificationsObservable(observable, customerId) {
        if (this.notificationsObservers[customerId] === undefined) {
            this.notificationsObservers[customerId] = [];
        }
        this.notificationsObservers[customerId].push(observable);
    }
}
Customer.G_TO_OZ = 0.03527396195;
Customer.OZ_TO_G = 28.3495231;
exports.default = Customer;
//# sourceMappingURL=Customer.js.map